import { Footer } from "./Components/Footer"
import "./styles.css"

export default function Bottom() {
    return (<Footer/>)
}
